import React from "react";

/* img imports */
import chefsBoard from "../assets/images/chefs-board.png";

const ChefsBoard = ({ handleRedirect }) => {
  return (
    <>
      <div
        className="chefs-board-wrapper"
        onClick={() => {
          handleRedirect("/chefs");
        }}
      >
        <img src={chefsBoard} alt="" />
      </div>
    </>
  );
};

export default ChefsBoard;
